module.exports = __webpack_public_path__ + "img/white10_128.95c0a158.png";